<template>
<div id="fastview">

<header-cont onpages="1" v-bind:buylink="buylink"></header-cont>
<!--header-->

<div class="discount wow flipInY" data-wow-delay="1.9s" v-if="isshow==1">
 <a href="javascript:;" class="close"><i></i></a>
 <a href="javascript:;" class="salebtn">
  <span>Get Now</span>
  <h2><i>$</i>{{price.discountPrice}}</h2>
  <p><del>${{price.orgPrice}}</del> (Perpetual)</p>
 </a>
</div>
<!--discount-->

<div class="discount_pop">
 <dl>
  <dt>For a limited time only </dt>
  <dd><i>{{zkfb}}%</i> OFF</dd>
 </dl>
 <div class="con">
  <div class="pic"><img src="../../static/images/book.png"></div>
  <ul>
   <li><h2><i>$</i>{{price.discountPrice}}</h2></li>
   <li><p><del>${{price.orgPrice}}</del> (Perpetual)</p></li>
   <li><a :href="downlink" onclick="gtag_report_conversion()" class="btnicon"><i></i><em>Buy Now</em></a></li>
  </ul>
 </div>
</div>
<!--discount_pop-->


<div class="bigbg">
 <h1 class="wow bounceIn" data-wow-delay="0.4s">DWG FastView Plus</h1>
 <div class="con">
  <div class="pic wow fadeInLeftSmall"  data-wow-delay="0.8s"><img src="../../static/images/banner.gif"></div>
  <div class="txt wow fadeInRightSmall"  data-wow-delay="0.9s">
   <h2 class="wow fadeInRightSmall" data-wow-delay="1s">Fast view  & Flexible measure & Easy share</h2>
   <p class="wow fadeInRightSmall" data-wow-delay="1.1s">DWG files without CAD software</p>
   <span  class="wow fadeInRightSmall" data-wow-delay="1.2s"><a href="https://www.youtube.com/watch?v=gDcVXpO6XV4" target="_blank"><i></i>Watch DWG FastView Plus in action</a></span>
   <div class="btn wow fadeInRightSmall" data-wow-delay="1.3s"><a href="javascript:;" class="n1 btnicon downlinkMar"><i></i><em>Try It Free</em></a><a :href="downlink" class="n2 btnicon"><i></i><em>Buy Now</em></a></div>
  </div>
 </div>
</div> 
<!--bigbg-->
 

<div class="dwg mainbox or">
 <div class="top or">
  <h2 class="wow fadeInUpSmall">DWG FastView Plus</h2>
  <p class="wow fadeInUpSmall">A lightest, easy-to-use viewer with  most compact interface plus tools for fast and simply view, measure, plot and share DWG/DXF files.</p>
  <a href="../Learnmore/index.html" class="wow fadeInUpSmall">Learn More</a>
 </div>
<!--top-->
 <div class="bottom or">
  <dl class="wow fadeInUpSmall" data-wow-delay="0s">
   <dt><img src="../../static/images/dwgfast_03.png"></dt>
   <dd><h3>Fastest & Lightest Viewer</h3></dd>
   <dd>Native AutoCAD 2018 drawing support Open large drawings within a few seconds Easy start without learning cost</dd>
  </dl>
  <dl class="wow fadeInUpSmall" data-wow-delay="0.2s">
   <dt><img src="../../static/images/dwgfast_05.png"></dt>
   <dd><h3>More Than a Viewer</h3></dd>
   <dd>Advanced measurement and dimensioning tools to enhance your team communication and data exchange </dd>
  </dl>
  <dl class="wow fadeInUpSmall last" data-wow-delay="0.3s">
   <dt><img src="../../static/images/dwgfast_07.png"></dt>
   <dd><h3>Secure Drawing Share</h3></dd>
   <dd>Share drawing data with your partners in an innovative, secured and reliable way. </dd>
  </dl>
 </div>
 <!--bottom-->
</div>
<!--dwg--> 
<div class="cl"></div>

<div class="measure or">
 <div class="mainbox">
  <div class="tab wow fadeInLeftSmall">
   <a href="javascript:;" class="active">Measure</a>
   <a href="javascript:;">Dimension</a>
   <a href="javascript:;">DWG Convert</a>
   <a href="javascript:;">Control & Manage</a>
   <a href="javascript:;">Compare Files</a>
   <a href="javascript:;">Print & Easy Share</a>
  </div>
  
  
  
  
  <div class="measure_con fadeInRightSmall">
   <div class="list">
    <h2><i><img src="../../static/images/dwgfast_13.png"></i>Measure</h2>
    <p>Get accurate information like distance, angle and area from 2D drawings in quick and intuitive ways</p>
	<div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/MEASURE.mp4"><img src="../../static/images/Measure.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/dimension.png"></i>Dimension</h2>
    <p>Produce clear and concise measured drawings with the most standard dimensioning tools like linear, align, angular and much more.</p>
	<div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/DIMENSION.mp4"><img src="../../static/images/Demension.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/convert.png"></i>DWG Convert</h2>
    <p>Convert one or a bunch of selected drawing files to other dwg versions available.</p>
	<div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/DWG CONVERT.mp4"><img src="../../static/images/DWGCONVERT.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/layercontrol.png"></i>Control & Manage</h2>
    <p>Control drawing layers’ visibility and manage object properties through properties palette.</p>
	<div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/Layers Control.mp4"><img src="../../static/images/controlmanage.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/compare.png"></i>Compare Files</h2>
    <p>Compare DWG files and highlight differences between drawing revisions such as entities removed, added or modified.</p>
	<div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/Compare Drawing.mp4"><img src="../../static/images/comparefiles.jpg"><em></em></a></div>
   </div>
   <div class="list">
    <h2><i><img src="../../static/images/print&share.png"></i>Print & Easy Share</h2>
    <p>Print and export drawings to Paper, PDF, PNG ....Easy share a drawing file for view only, or send an e-mail attachment to others.</p>
	<div class="pic"><a href="javascript:;" data-videoscure="http://view.cadwonder.net/static/video/PRINT AND SHARE.mp4"><img src="../../static/images/Print.jpg"><em></em></a></div>
   </div>
  </div>
  <!--measure_con-->
  
  
  
  
  
  
  
  
  
  
  
 </div>
 <!--mainbox-->
</div>
 <!--measure-->
 
 <div class="seewhat mainbox">
  <h2 class="wow fadeInUpSmall" data-wow-delay="0s">See What Users Are Saying About<span>DWG FastView Plus</span></h2>
  <div class="con">
   <div v-for="(item,index) in ReviewList" class="list wow fadeInUpSmall" data-wow-delay="0s">
    <a href="../review/index.html">
     <p>{{item.content}}</p>
     <div class="bottom" v-bind:style="item.backcolor">
      <dl>
       <dt><div class="reavwname">{{item.nameone}}</div></dt>
       <dd><h3>{{item.name}}</h3>{{item.country}}</dd>
      </dl>
      <span>MORE</span>
     </div>
    </a>
   </div>
   
   
  </div>
  <!--con-->
  <div class="cl"></div>
  
  <div class="write wow fadeInUpSmall" data-wow-delay="0.4s"><span><a href="../reviewadd/index.html" class="btnicon"><i></i><em>Write a Review</em></a></span></div>
  
 </div>
 <!--seewhat-->
 
 <footer-cont v-bind:buylink="buylink"></footer-cont>
 <!--底部结束-->
 <!--侧边栏-->
 <ul class="side-bar slideInRight">
  <li class="s1"><a href="https://www.facebook.com/DWG-FastView-Plus-968128393349711/" target="_blank"><i></i></a></li>
  <li class="s2"><a href="https://twitter.com/Gstarsoft_CAD" target="_blank"><i></i></a></li>
  <li class="s3"><a href="https://www.youtube.com/channel/UCtYObLC_uoUtObVFx71Tn9w" target="_blank"><i></i></a></li>
 </ul>
 
 <div class="loaded">
    <div class="loading">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</div>
 
</div>




</template>


<script>
	export default {
	  name: 'fastview',
	  data () {
		return {
		    id:1,
			LanguageList:[],  //语言列表
			ReviewList:[],   //评论列表
			bit:'32',          // 下载 选择的 bit
			checkedlang:'English',  // 下载选择的语言版本
			checkedlangval:'en',  // 下载选择的语言版本
			Colunmlist:[],        //栏目列表
			price:[],
			downlink:'',
			buylink:'',
			zkfb:'',
			isshow:1
		}
	  },
	  created:function(){
		
		this.Getlanage();
		this.GetReview();
		this.Getcolunmlist();
		this.getprice();
		this.getkey();
		

		
		
		
	},	
		
	methods:{
		
		//获取语言
		Getlanage:function(){
		    var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchLanguage',
			  data: {productId:ProductId,pageNo:0,pageSize:5},
			  'Content-Type':"application/json",
			  success:function(res){
				  fastview.LanguageList = res.bizData.list;
			  }
		  })
		},
		
		//获取seo
		getkey:function(){
		  
		  var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchSEO',
			  data: {productId:ProductId,pageCode:'index_en'},
			  'Content-Type':"application/json",
			  success:function(res){
				  console.log(res);
				  document.title = res.bizData.list[0].title;
				  var metas = document.getElementsByTagName("meta");
				  metas[6].content = res.bizData.list[0].keywords;
				  metas[7].content= res.bizData.list[0].description;
			  }
		  })
		  
		},
		
		//获取评价
		GetReview:function(){
		    var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchReviewList',
			  data: {productId:ProductId,pageNo:0,pageSize:4},
			  'Content-Type':"application/json",
			  success:function(res){
				  $.each(res.bizData.list,function(i,v){
					  var backcolor;
					  if(i==0){
						  backcolor = 'backgroundColor:#4488c4';
					  }
					  if(i==1){
						  backcolor = 'backgroundColor:#e29c69';
					  }
					  if(i==2){
						  backcolor = 'backgroundColor:#52afbf';
					  }
					  if(i==3){
						  backcolor = 'backgroundColor:#898ec1';
					  }
					  res.bizData.list[i].backcolor = backcolor;
                      
					  res.bizData.list[i].nameone = res.bizData.list[i].name.charAt(0);
					  
				  })
				  fastview.ReviewList = res.bizData.list;
			  }
		  })
		},
		
		//下载
		Getdownlink:function(){
			var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/downInstallPackage ',
			  data: {productId:ProductId,versionId:'1',lang:this.checkedlangval,bit:this.bit},
			  'Content-Type':"application/json",
			  success:function(res){
				 
			  }
		   })
			
		},
		
		//获取栏目
		Getcolunmlist:function(){
			var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/searchContent ',
			  data: {productId:ProductId,channelCode:'case',lang:'en',pageNo:0,pageSize:3},
			  'Content-Type':"application/json",
			  success:function(res){
				  //console.log(res);
			  }
		   })
			
		},
		
		//获取版本价格 buy 链接
		getprice:function(){
			var fastview = this;
			$.ajax({
			  type: 'POST',
			  url: BaseUrl+'/web/getProductPrice',
			  data: {productId:ProductId,versionId:'1',lang:'en'},
			  'Content-Type':"application/json",
			  success:function(res){
			      
			      
				  fastview.$nextTick(function(){
					 $(".loaded").hide();
				  })
				  
				  fastview.price = res.bizData;
				  
				  fastview.zkfb = parseInt(((res.bizData.orgPrice - res.bizData.discountPrice)/res.bizData.orgPrice * 100).toFixed(2));
				  
				  fastview.downlink = res.bizData.saleUrl;
				  fastview.buylink = res.bizData.saleUrl;
				  
				  if(res.bizData.discountPrice==res.bizData.orgPrice){
				     
					 fastview.isshow = 0;
				  
				  }
				  
			  }
		   })
			
		},
		
	}

	  
	}
	
	
</script>



// WEBPACK FOOTER //
// src/en/index.vue